/**
 * 更新函数类型
 */
export type UpdateFunction = (value: any) => void | Promise<void>;

/**
 * WeakMap存储更新函数
 * 用于将更新函数绑定到DOM元素上
 */
export const updateHandlersMap = new WeakMap<HTMLElement, UpdateFunction>();
